<template>
  <div class="px-4 pb-4">
    <data-table :columns="columns" :rows="rows">
      <template v-slot:actions="slotProps">
        <div class="button-items">
          <b-button v-if="checkForPermission(view_single_warehouse_permission)" variant="info" size="sm" class="py-1 text-white" @click="viewStock(slotProps.row.publicId)">
            View Warehouse
          </b-button>
          <b-button v-if="checkForPermission(edit_warehouse_permission)" v-b-modal.edit-warehouse variant="success" size="sm" class="py-1 text-white" @click="selectWarehouse(slotProps.row)">
            Edit Warehouse
          </b-button>
        </div>
      </template>
    </data-table>
    <b-modal
        id="edit-warehouse"
        centered
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Warehouse</h3>
        <new-warehouse-form-component button_text="Edit Warehouse" :selected_warehouse="selected_warehouse" @warehouseAction="warehouseAction"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-warehouse')">Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {routeItems} from "@/router/endpoints";
import NewWarehouseFormComponent from "@/components/warehouse/new-warehouse-form-component";
import DataTable from "@/components/data-table";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {permissions} from "@/router/permissions";

export default {
name: "warehouse-table",
  components: {DataTable, NewWarehouseFormComponent},
  data(){
    return{
      selected_warehouse: {},
      warehouses: {
        objects: []
      },
      view_single_warehouse_permission: permissions.view_single_warehouse_permission,
      edit_warehouse_permission: permissions.edit_warehouse_permission,
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'description',
          label: 'Description'
        },
        {
          field: 'isActive',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
    }
  },
  props: {
    rows: {type:Array}
  },
  methods: {
    ... mapActions({
      updateWarehouse: 'stock/updateWarehouse'
    }),
    viewStock(public_id){
      this.$router.push(routeItems.single_warehouse_stock_route+'/'+public_id)
    },
    async warehouseAction(data){
      data.id = this.selected_warehouse.publicId
      await this.updateWarehouse(data).then(resp => {
        if(resp.publicId){
          this.$emit('updateWarehouse')
          successToast(`${resp.name} updated successfully`)
        }
      })
    },
    selectWarehouse(row){
      this.selected_warehouse = row
    }
  }
}
</script>

<style scoped>

</style>
